import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import toObject from 'dayjs/plugin/toObject'

export default {
  getAge(dateString) {
    dayjs.extend(customParseFormat)
    dayjs.extend(toObject)

    const now = dayjs().toObject()
    const dob = dayjs(dateString, 'DD.MM.YYYY').toObject()

    let monthAge
    let dateAge
    let yearAge = now.years - dob.years

    if (now.months >= dob.months) {
      monthAge = now.months - dob.months
    } else {
      yearAge--
      monthAge = 12 + now.months - dob.months
    }

    if (now.date >= dob.date) {
      dateAge = now.date - dob.date
    } else {
      monthAge--
      dateAge = 31 + now.date - dob.date

      if (monthAge < 0) {
        monthAge = 11
        yearAge--
      }
    }

    return {
      years: yearAge,
      months: monthAge,
      days: dateAge
    }
  }
}
